import Flickity from 'flickity';
import 'flickity-imagesloaded';

const initSlider = (module_name, i) => {
  const container = document.getElementById(`Module-${module_name}--${i}`);
  const carousel = container.querySelector('[data-cms-image-slider]');
  const options = {
    wrapAround: true,
    dragThreshold: 10,
    imagesLoaded: true,
    arrowShape:
      'M72.796,0.001c-1.314,0.168 -1.563,0.449 -2.17,0.998l-47.051,47.052l47.211,50.818c1.883,1.878 3.088,1.018 4.202,0.262c1.654,-1.123 1.921,-3.596 0.588,-5.185l-42.451,-45.718l42.598,-42.624c1.653,-2.251 0.05,-5.678 -2.927,-5.603Z',
  };
  let slider = new Flickity(carousel, options);
  console.log(slider);
};

export { initSlider };
